import React from "react";
import { AlertTriangle } from "lucide-react";
import { Button } from "../ui/button";
import { FormError } from "../ui/feedback";
import { FlowpiAlertDialog } from "../ui/flowpi-dialog";

export default function QuotationConfirmationDialog({
  open,
  title,
  message,
  confirmLabel,
  onCancel,
  onConfirm,
  busy = false,
  busyLabel = "Working...",
  error = "",
  testid = "quotation-confirmation",
  eyebrow = "Permanent action",
}) {
  if (!open) return null;

  const footer = (
    <>
      <Button type="button" variant="neutral" onClick={onCancel} disabled={busy}>Cancel</Button>
      <Button type="button" variant="destructive" onClick={onConfirm} loading={busy} loadingLabel={busyLabel}>
        {confirmLabel}
      </Button>
    </>
  );

  return (
    <FlowpiAlertDialog open={open} onClose={onCancel} busy={busy} eyebrow={eyebrow} title={title} footer={footer} testId={testid}>
      <div className="space-y-3">
        <div className="flex items-start gap-3 text-sm text-muted-foreground">
          <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-destructive" aria-hidden="true" />
          <p>{message}</p>
        </div>
        <FormError>{error}</FormError>
      </div>
    </FlowpiAlertDialog>
  );
}
